import React, { FunctionComponent } from 'react';
import { Navigate } from 'react-router-dom';
import { Loader } from 'rs-emd-ui-atoms';
import { OrderHistoryPage, useOrderHistoryPageQuery } from '../../../generated/graphql';
import { MyAccountOrders } from '../../../rs-emd-ui-modules/src/components/user/my-account/my-account-orders';
import { RedirectWithStatus } from '../../../rs-emd-ui-modules/src/helpers/redirect-with-status.component';
import { getAccountOrdersViewByCookie } from '../../../rs-emd-ui-modules/src/helpers/user-settings.utils';

export const MyAccountOrdersWrapper: FunctionComponent = () => {
  const { loading, error, data } = useOrderHistoryPageQuery({
    fetchPolicy: 'cache-first',
  });

  if (loading) {
    return <Loader />;
  } else if (error || !data) {
    return <RedirectWithStatus to={process.env.REACT_APP_ERROR_ENDPOINT} statusCode={500} />;
  } else if (!data.orderHistoryPage.isSuccess) {
    return <Navigate to='/user/login?redirectTo=/user/myaccount/orders' />;
  } else return <MyAccountOrders data={data.orderHistoryPage as OrderHistoryPage} viewBy={getAccountOrdersViewByCookie()} />;
};

export default MyAccountOrdersWrapper;
